import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0efcc76d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "list-item"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "item-right"
};
const _hoisted_5 = {
  class: "item-title"
};
const _hoisted_6 = {
  class: "item-time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_van_list = _resolveComponent("van-list");

  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
    modelValue: $setup.loading,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.loading = $event),
    onRefresh: $setup.refresh,
    class: "refresh-main"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_list, {
      class: "van-main",
      loading: $setup.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.loading = $event),
      finished: $setup.finished,
      "finished-text": "没有更多了",
      onLoad: $setup.load,
      offset: "200"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
        return _openBlock(), _createBlock(_component_router_link, {
          to: {
            name: 'NetNotice',
            params: {
              id: item.id
            }
          },
          key: index
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
            src: item.image,
            class: "item-img"
          }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_6, _toDisplayString($setup.curentTime(item.createTime)), 1)])])]),
          _: 2
        }, 1032, ["to"]);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])]);
}